import {cursorTarget, setCursor} from "../../utils/utils";
import * as Globals from "../../globals";
import {SupportBeamPreview} from "./supportBeamPreview";
import {clearStates, scenesContainer, syncShellMenu, tmpGroup, toggleModeButtons} from "../../main";
import {generateMeasurements, refreshWallHeightLabels} from "../measurements/measurementGeneration";
import {frameBuilding} from "../../utils/cameraUtils";
import {recalculateBuildingParameters} from "../../calculators/buildingParameters/parameterCalculator";
import {clearGroup, render} from "../../sceneManager";
import {updateWallSnapAxis} from "../walls/wallGeneration";
import {regenerateRoof} from "../roofs/roofGeneration";
import {regenerateFloor} from "../floor/floorGeneration";
import {createRooms} from "../rooms/roomGeneration";

let currentPreview = null;
let input = $('#generic-length-input');

export function startBeamPreview(size, forceEvenPillarAmount) {
    currentPreview = new SupportBeamPreview(size, forceEvenPillarAmount);
    setCursor(Globals.cursors.crosshair, cursorTarget.layoutView);
}

let inputString = "";

function getWallLengthInput(e) {
    input.focus();

    try {
        let value = parseFloat(e.target.value);
        if (!isNaN(value)) {
            if (value > 100 || value < 0) {
                if (value > 100) {
                    input.val(100);
                }
                return;
            }
            currentPreview.adjustSecondPreview(value);
        } else {
            currentPreview.adjustSecondPreview();
        }
    } catch {
    }

    if (e.code === 'Enter' || e.code === "NumpadEnter") {
        console.log("test");
        beamClick();
        input.val("");
        input.focus();
    }

    render();
}

function updateInputPosition(e) {
    let size = scenesContainer.getBoundingClientRect();
    let left = Math.min(e.clientX - size.left + 10, $('#scenesContainer').width() - input.width());
    let top = Math.min(e.clientY - size.top + 10, $('#scenesContainer').height() - input.height());
    input.css({"left": left, "top": top});
}


export function adjustBeamPreview() {
    if (currentPreview === null) {
        console.error("Currently no support beam preview exists");
        return;
    }

    if (currentPreview.firstPreviewMesh !== null) {
        if (currentPreview.secondPreviewMesh === null) {
            currentPreview.adjustFirstPreview();
        } else {
            input.focus();

            try {
                let value = parseFloat(input.val());
                if (!isNaN(value)) {
                    if (value > 100 || value < 0) {
                        if (value > 100) {
                            input.val(100);
                        }
                        return;
                    }
                    currentPreview.adjustSecondPreview(value);
                } else {
                    currentPreview.adjustSecondPreview();
                }
            } catch {
            }
        }
    } else {
        console.error("No first preview mesh for wall exists");
    }
}

export function beamClick() {
    if (currentPreview === null) {
        console.error("Currently no wall preview exists");
        return;
    }

    if (currentPreview.firstPreviewMesh !== null) {
        if (currentPreview.secondPreviewMesh === null) {
            if (currentPreview.validFirstPosition) {
                currentPreview.createSecondPreview();
                document.addEventListener('keyup', getWallLengthInput);
                scenesContainer.addEventListener('mousemove', updateInputPosition);
                inputString = "";
                input.removeClass('d-none');
                input.focus();
            }
        } else {
            if (currentPreview.validSecondPosition) {
                let keepAdding = currentPreview.createBeamFromPreview();
                if (!keepAdding) {
                    currentPreview = null;
                    inputString = "";
                    clearStates();
                    createRooms();
                    regenerateRoof();
                    regenerateFloor();
                    generateMeasurements().then();
                    recalculateBuildingParameters().then();
                    toggleModeButtons();
                }

                updateWallSnapAxis();
                syncShellMenu();
                refreshWallHeightLabels();
                frameBuilding();
            }
        }
    } else {
        console.error("No first preview mesh for support beam exists");
    }

    input.focus();
}

export function deleteBeam(beam) {
    clearGroup(beam);
    beam.removeFromParent();
}

export function clearBeamPreviewState() {
    clearGroup(tmpGroup);
    currentPreview = null;
    document.removeEventListener('keyup', getWallLengthInput);
    scenesContainer.removeEventListener('mousemove', updateInputPosition);
    input.addClass('d-none');
    input.val("");
}
